define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/def",
	"csi/def/Field",
	"csi/def/ViewRef",
	"csi/reflection",
	"csi/table/NewFrom",
	"csi/xml"
], function(declare, lang, _, def, Field, ViewRef, reflection, NewFrom, xml) {

	var COMBINEPATH = xml.path("Actual", "Definition");
	var DATASHEET_ITEM_FORM_ID = "SpecificationDataSheetItem";
	var DEFINITION = "Definition";
	var DEFINITION_FORM_ID = "SpecificationItemDefinition";
	var DESCRIPTION = "Description";
	var PATH_SSI = xml.path("Actual");
	var SECTION_ITEM_FORM = "Actual";
	var SECTION_ITEM_FORM_ID = "SpecificationSectionItem";
	var SECTION = "SpecificationSection";
	var SPEC_ITEMS = "SpecItems";

	return declare(NewFrom, {

		// the fields with path(from SID form with two-level aggregation) need to be populated
		// so don't use the view node
		bUseNodeForForm: false,

		/**
		 * Combine the SID form, SSI form
		 * Handle the Description attribute from two forms(SID&SSI)
		 * @param {csi.view.Widget} view
		 */
		onCreatePopup: function(view) {
			var w = this.widget;
			view.sectionsStore = w.getEditableSectionsStore();

			this.inherited(arguments);

			if (view.defView.m_id == def.DEFAULT_FORM_ID) {

				// introduce the field used to connect them together
				var definitionRef = lang.mixin(new Field(), {
					m_id: DEFINITION,
					m_path: PATH_SSI
				});

				view.insertField(definitionRef);
				view.addFixedValue(DEFINITION, this.getNode().$URL);
				view.getField(DEFINITION).bHidden = true;

				view.combineForm(true, SECTION_ITEM_FORM);

				// add the description attribute of the SSI form by default if not exist
				if (!view.getField(view.getCombinedFieldName(SECTION_ITEM_FORM_ID, DESCRIPTION))) {
					var f = lang.mixin(new Field(), {
						m_id: DESCRIPTION,
						m_path: PATH_SSI
					});

					view.insertField(f, 0);
				}

				view.addFixedValue(DESCRIPTION, this.getNode().Description);

				view.combineFormAlongPath(true, COMBINEPATH, {m_right: xml.RIGHT_NONE});

				// check if description attribute of the SDI form exist, if it does, remove it
				view.defView.removeField(view.getCombinedFieldName(DEFINITION_FORM_ID, DESCRIPTION));
			}
		},

		/**
		 * Prevent the definition from being picked up more than once
		 * @param {FormData} fd
		 * @return {FormData}
		 */
		onFormData: function(fd) {
			if (this._groupResults) {
				var sectionUrl = this._groupResults[0].groupValue;
				var sectionItems = this.getCache().getNode(sectionUrl).SectionItems;
				var self = this;

				_.forEach(sectionItems, function(sectionItem) {
					var definition = self.getCache().getNode(sectionItem).Definition;
					var item = self.getCache().getNode(definition);
					fd.addAggregatedNode(item);
				});
			}
		},

		getActionView: function(vr) {
			if (this.isToolbarAction()) {
				vr = new ViewRef();
				vr.m_id = "SpecItemSelectionForm";
			}
			return this.inherited(arguments, [vr]);
		},

		/**
		 * Get URL of selected section
		 * @return {string}
		 */
		getSection: function() {
			var fd = this.m_formData;
			return fd && fd.getFieldValue(SECTION);
		},

		/**
		 * Return true, if action activated from toolbar (vs from group row)
		 * @return {boolean}
		 */
		isToolbarAction: function() {
			return this.widget.isNewActionsButton(this.refNode);
		},

		/**
		 * If action initiated from toolbar, make sure selected nodes present in the cache
		 * @override
		 */
		process: function() {
			var self = this;
			var section = this.getSection();
			if (section) { // Action called from toolbar
				var fd = this.m_formData;
				var urls = fd.getFieldValue(SPEC_ITEMS);
				var dfd = this.getCache().getNodeDependencies(urls);

				this.when(dfd, function() {
					NewFrom.prototype.process.call(self);
				});
			} else { // Action called from group action row button
				this.inherited(arguments);
			}
		},

		/**
		 * If action initiated from toolbar, add "Section" parameter to each element of the request
		 * @override
		 */
		toWriter: function() {
			var call = this.inherited(arguments);
			var section = this.getSection();
			if (call && section) {
				call.addParameter("Section", xml.ATTR_REF, section);
			}

			return call;
		},

		/**
		 * If action initiated from toolbar, get data from multiselect dropdown
		 * @override
		 */
		storeSources: function() {
			this.inherited(arguments);
			// If action initiated from toolbar
			if (this.isToolbarAction()) {
				var fd = this.m_formData;
				var selection = fd.getFieldValue(SPEC_ITEMS);
				fd.resetSelections();
				this.m_aSources = _.map(selection, function(nodeUrl) {
					return this.getCache().getNode(nodeUrl);
				}, this);
				this._sourceSelectedLength = this.m_aSources.length;
			}
		},

		/**
		 * Check if SSI, SDI have form defined, pop up the form as needed
		 * If SDI has form, no matter if SSI has or not, show it; If SDI doesn't have a Form, but SSI does, then show it as well; otherwise don't show it.
		 * @param {Node} node
		 * @param {Boolean} bCheckOnly
		 */
		_getFormView: function(node, bCheckOnly) {
			var defView = this.inherited(arguments);
			var primaryFormView = def.getClassViewDef(reflection.getClass(DATASHEET_ITEM_FORM_ID), def.DEFAULT_FORM_ID);
			var secondaryFormView = def.getClassViewDef(reflection.getClass(SECTION_ITEM_FORM_ID), def.DEFAULT_FORM_ID);

			// for the SDI form, we have defined the OOTB Form without any fields via the XML by default, so we check the length of fields
			// but for the SSI form, we don't define the OOTB Form, so just check if there is a view
			return primaryFormView.m_fields.length > 0 ? defView : (secondaryFormView ? defView : null);
		},

		/**
		 * @override
		 * Make sure section and items are in the cache (see onFormData)
		 */
		onPreActionDeferreds: function(dfds) {
			var qr = this.widget.getQueryResultByDomNode(this.m_element);
			var qrGroup = qr.parentResult;
			dfds.push(this.getCache().getNodeDependencies(qrGroup.groupValue, [xml.path("SectionItems", "Definition")]));
		},

		/**
		 * Add the section attribute
		 * @param {CallMethod} call
		 * @return {Boolean}
		 */
		_writeRequestParameters: function(call) {
			this.inherited(arguments);

			if (this._groupResults) {
				this._groupResults.every(function(groupResult, index) {
					var groupUrl = groupResult.groupValue;
					var groupId = groupResult.level.groupSpec.heading.m_id;

					if (groupId == "Section") {
						call.addParameter("Section", xml.ATTR_REF, groupUrl);
					}

					return false;
				});
			}
		}
	});
});